import queryString from "query-string"

export const serialize = (obj: { [key: string]: any }): string => {
  return queryString.stringify(obj, {arrayFormat: 'comma'})
}
export const parse = (query: string): { [key: string]: any } => {
  return queryString.parse(query, {arrayFormat: 'comma'})
}